import React from "react";
import axios from "axios";
import {isMobileOnly} from "react-device-detect";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import magnifier from '../../assets/magnifier.svg';
import Moment from "react-moment";
import DoubleTemplateComponent
    from "../../containers/template_page/double_template_component/double_template_component";
import './c41_avvisi.scss';

const SVG_ID = "#svg_id";

/* Content of the month dropdown */
const optionsMonths = [
    {value: '', label: 'All Months'},
    {value: '-01', label: 'Gennaio'},
    {value: '-02', label: 'Febbraio'},
    {value: '-03', label: 'Marzo'},
    {value: '-04', label: 'Aprile'},
    {value: '-05', label: 'Maggio'},
    {value: '-06', label: 'Giugno'},
    {value: '-07', label: 'Luglio'},
    {value: '-08', label: 'Agosto'},
    {value: '-09', label: 'Settembre'},
    {value: '-10', label: 'Ottobre'},
    {value: '-11', label: 'Novembre'},
    {value: '-12', label: 'Dicembre'}
];

class AvvisiGrid extends DoubleTemplateComponent {

    uuid = '';
    date = '';
    month = '';

    constructor(props) {
        super(props);
        this.state = {
            optionsCategory: [],
            arrayCallCat: [],
            disabled: true,
            searchTerm: '',
            isHidden: true,
            filters: ['title', 'date']
        };
        this.notizieRef = React.createRef();

        this.requireInternationalization = true;
    };

    componentDidMount() {
        super.componentDidMount();

        //create date from 2015 to current year
        var startYear = '2015';
        var currYear = new Date().getFullYear();
        var arrYear = [];
        for (startYear; startYear<currYear+1; startYear++){
            arrYear.push(startYear);
        }
        arrYear.unshift('Years');
        this.setState({
            optionsYears: arrYear
        });
    }

    onOtherDataLoaded(index, data) {
        this.setState({
            optionsCategory: data.terms.map(el => el.label),
            arrayCallCat: data.terms
        });
        this.state.optionsCategory.unshift('All');
    }

    callFilter = () => {

        let params = {};
        params['views'] = true;
        params['limit'] = 9;

        let category = this.uuid;
        if (category) {
            params['category'] = category;
        }
        let date = this.date;
        let month = this.month;
        if (date || month) {
            params['date'] = date + month;
        }

        if (document.forms.searchForm && document.forms.searchForm.search && document.forms.searchForm.search.value) {
            params['search'] = document.forms.searchForm.search.value;
        }

        axios.get(this.state.data.__data, {params: params}).then(res => {
            this.setState({
                data: {...this.state.data, ...res.data},
                searchTerm: res.data.title
            });
        });
    };

    changeCategory = selected => {

        selected = selected.value;
        this.getValCat(selected);
        if (selected === 'All') {
            selected = '';
            this.uuid = '';
            this.callFilter();
        }

        // for each category in arrayCallCat find uuid based on selected value of category name
        this.state.arrayCallCat.forEach((filterString) => {
            for (var key in filterString){
                if(filterString[key] === selected){
                    this.uuid = filterString.id;
                    return this.callFilter();
                }
            }
        })
    };

    changeYear = selected => {
        this.disableDrop(false);
        selected= selected.value.toString();
        this.getValYear(selected);
        if (selected === 'Years') {
            selected = ''
            this.disableDrop(true);
            this.month = '';
            this.getValMonth('');
        }

        this.date = selected;
        this.callFilter();
    };

    changeMonth = selected => {
        selected= selected.value;
        this.getValMonth(selected);
        if (selected === 'Month') {
            selected = ''
        }
        this.month = selected;
        this.callFilter();
    };

    getValCat = val =>{
        this.setState ({valueCat: val});
    };
    getValYear = val =>{
        this.setState ({valueYear: val});
    };
    getValMonth = val =>{
        this.setState ({valueMonth: val});
    };

    searchUpdated = event => {
        event.preventDefault();
        this.callFilter();
    };

    disableDrop = (value) => {
        this.setState({disabled: value})
    };

    showMore = ep => {
        axios.get(ep, {
        }).then(res => {

            let cards = this.state.data.cards.concat(res.data.cards);

            this.setState({
                callMore: true,
                data: {...this.state.data, ...{cards: cards, next_page: res.data.next_page}}
            });
        });
    };

    internationalComponentRender(allData, t) {
        console.log('[LOG]: ALLDATA: ', allData);
        let filteredCards = allData.cards;

        const { valueCat, valueYear, valueMonth, isHidden } = this.state;

        return (
            <div id={!isMobileOnly ? 'avvisi-grid' : 'avvisi-grid-mob'} className="c41-avvisi">
                <div className="container container-search-fields">
                    <div className="row">
                        <Dropdown
                            options={this.state.optionsCategory}
                            onChange={this.changeCategory}
                            value={valueCat}
                            placeholder="All"
                            className={!isMobileOnly ? 'dropdown-categories col-4' : 'dropdown-categories'}
                        />
                        <Dropdown
                            options={optionsMonths}
                            onChange={this.changeMonth}
                            value={valueMonth}
                            disabled = {this.state.disabled}
                            placeholder="Month"
                            className={!isMobileOnly ? 'dropdown-months col-2' : 'dropdown-months'}
                        />
                        <Dropdown
                            options={this.state.optionsYears}
                            onChange={this.changeYear}
                            value={valueYear}
                            placeholder="Year"
                            className={!isMobileOnly ? 'dropdown-years col-2' : 'dropdown-years'}
                        />
                        <form onSubmit={this.searchUpdated} name="searchForm"
                            className={!isMobileOnly ? 'search-bar-avvisi col-4' : (!isHidden ? 'search-bar-avvisi' : "search-bar-avvisi text-right")}>
                            <button className="avvisi-search-button" type="submit">
                                <svg className="magnifier-avvisi">
                                    <use xlinkHref={`${magnifier}${SVG_ID}`}/>
                                </svg>
                            </button>
                            <input name="search" className="search-input" />
                        </form>
                    </div>
                </div>
                <div className="container">
                    <div className="row avvisi-card-row">
                        {(filteredCards && filteredCards.length > 0) ? filteredCards.map((card, index) => {

                            let categoryLabel;
                            if (card.category && card.categories && card.categories.length > 0) {
                                if (card.categories.find(cat => cat.label === valueCat)) {
                                    categoryLabel = valueCat;
                                } else {
                                    categoryLabel = card.categories[0].label;
                                }
                            }

                            return (
                                <div className="col-xl-4 col-md-6" key={index}>
                                    <div className="avvisi-card mx-auto">
                                        {categoryLabel ?
                                            <div className="avvisi-card-category">
                                                {categoryLabel}
                                            </div>
                                            :
                                            <div className={'separator'} />
                                        }
                                        <div className="avvisi-card-title">{card.title}</div>
                                        {card.date ? <div className="avvisi-card-date"><Moment date={card.date} format="D MMMM YYYY" /></div> : null}
                                        <div className="avvisi-card-cta"><a href={card.link_url}>{card.link_title}</a>
                                        </div>
                                    </div>
                                </div>
                            )
                        }) : <p className={'not-found'}>{t("C41 grid no content")}</p>}
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                {(allData.next_page !== '' && filteredCards && filteredCards.length > 0) &&
                                    <button className="avvisi-carica-altro-btn"
                                            onClick={() => this.showMore(allData.next_page)}>{allData.loadmore_label}</button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AvvisiGrid;
